module.exports = __webpack_public_path__ + "media/images/star-4433509f22bac2fecd8aa86533f860b9.svg";